// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".L2ZYX8TxirhkhcmiDw6K,.x9ikxbjXg94XJb3xKseT,.VdUZO6RLcXp2h1V8B89j{grid-column:1/-1}.aB94lDiW1UmiSP5U404n{grid-column:1/-1}.L2ZYX8TxirhkhcmiDw6K{margin-bottom:26px}.L2ZYX8TxirhkhcmiDw6K:first-child{margin-top:50px}@media(max-width: 767px){.L2ZYX8TxirhkhcmiDw6K{margin-bottom:10px}}.x9ikxbjXg94XJb3xKseT{margin-bottom:28px}@media(min-width: 768px){.x9ikxbjXg94XJb3xKseT{margin-bottom:50px}}.VdUZO6RLcXp2h1V8B89j{margin-bottom:28px}._xck6iXLdaPh9jZnEaQI{display:flex;align-items:center;justify-content:center;padding:34px 14px;text-transform:uppercase}._xck6iXLdaPh9jZnEaQI p{color:#cbd5e0 !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layoutTitle": "L2ZYX8TxirhkhcmiDw6K",
	"layoutUpcomingAppointments": "x9ikxbjXg94XJb3xKseT",
	"layoutPassedAppointments": "VdUZO6RLcXp2h1V8B89j",
	"layout": "aB94lDiW1UmiSP5U404n",
	"emptyTextContainer": "_xck6iXLdaPh9jZnEaQI"
};
export default ___CSS_LOADER_EXPORT___;
